module.exports = __webpack_public_path__ + "img/ecobanka_claro.9e4d5176.png";